<template>
    
        <button type="button" id="botaoOuvir" class="btn btn-success" v-on:click="start()" v-if="!record">
            <i class="fas fa-microphone"></i> Iniciar Leitura
        </button>

        <button type="button" class="btn btn-success" v-if="record" style="cursor:none; margin-right:10px;">
            <i class="fas fa-headset"></i> Analisando
        </button>

        <button type="button" class="btn btn-danger" v-on:click="stop()" v-if="record">
            <i class="fas fa-stop"></i> Parar Leitura
        </button>
        
</template>

<script>
    export default {
        name: 'Microphone',
        data() {
            return {
                record: false,
                text: ''
            }
        },
        methods: {
            start() {
                let $this = this;
                //console.log(window.top);
            
                //// Verificar se navigator.mediaDevices.getUserMedia está disponível no documento pai
                //if (window.top.navigator && window.top.navigator.mediaDevices && window.top.navigator.mediaDevices.getUserMedia) {
                //    // Solicitar permissão para acessar o microfone ao documento pai
                //    window.top.navigator.mediaDevices.getUserMedia({ audio: true })
                //        .then(function (stream) {
                //            console.log('Permissão concedida!');
                //            // Faça algo com o stream de áudio, se necessário
                //        })
                //        .catch(function (err) {
                //            console.error('O usuário não concedeu permissão ou ocorreu um erro: ', err);
                //        });
                //} else {
                //    console.error('Não foi possível solicitar permissões ao documento pai.');
                //}

                //window.SpeechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition;
                
                //if ('SpeechRecognition' in window.window) {
                    
                    
                //    const recognition = new window.SpeechRecognition();

                    
                //    recognition.interimResults = true;

                //    recognition.start();

                    
                //    recognition.addEventListener('result', (e) => {
                //        const textoTranscrito = Array.from(e.results)
                //            .map(result => result[0].transcript)
                //            .join('');

                //        $this.text = textoTranscrito;
                //    });

                //    recognition.addEventListener('end', () => {
                //        // Reinicia o reconhecimento de voz quando terminar
                //        recognition.start();
                //    });
                //} else {
                //    console.log('4');                    
                //}
                //console.log('5');
                this.record = true;
            },
            stop() {
                this.record = false;
            }
        }
    }
</script>

<style scoped>
</style>
